import { useMutation } from '@apollo/client'
import { Typography, Button } from '@mui/material'
import { useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { withSnackbar } from 'src/context/SnackbarProvider'
import SnackbarContext from 'src/hooks/useSnackbar'
import { Mutation_UPSERT_FEEDBACK } from 'src/queries/Feedback'
import { Mutation, MutationUpsertUserFeedbackArgs } from 'src/types/graphql'
import styled from 'styled-components'
//@ts-ignore
import IntroImg from 'src/assets/intro.jpg'
import AsyncButton from 'src/components/AsyncButton/AsyncButton'

const StyledDiv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    width: 625px;

    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
`

const StyledImg = styled.img`
    width: 100%;
    border-radius: 5px;
`

const StyledTypgraphy = styled(Typography)`
    font-size: 2.6rem;
`

const StyledButton = styled(AsyncButton)`
    width: 200px;
    text-transform: none;
`

export const FeedbackIntro = withSnackbar(() => {
    const navigate = useNavigate()
    const { createSnackbar } = useContext(SnackbarContext)
    const { search } = useLocation()
    const queryParams = new URLSearchParams(search)
    const data = queryParams.get('data')
    const iv = queryParams.get('iv')

    const [upsertUserFeedback] = useMutation<Pick<Mutation, 'upsertUserFeedback'>, MutationUpsertUserFeedbackArgs>(Mutation_UPSERT_FEEDBACK)

    const onStartFeedback = async () => {
        if (!data || !iv) {
            createSnackbar('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.', 'error')
            return
        }
        try {
            const res = await upsertUserFeedback({
                variables: { encryptedUserData: { encryptedUserMessageBase64: data, ivHex: iv } },
            })
            if (res.data?.upsertUserFeedback) {
                navigate(`/feedback?data=${data}&iv=${iv}`)
            }
        } catch (err: any) {
            createSnackbar(err.message, 'error')
        }
    }

    return (
        <StyledDiv>
            <StyledImg src={IntroImg} alt="Feedback-intro" />
            <StyledTypgraphy variant="h3" fontWeight={600}>
                Deine Meinung ist uns wichtig.
            </StyledTypgraphy>
            <Typography variant="body1" textAlign="center">
                Hast du Lust, unsere Software mitzugestalten? Sag uns gerne, was du über marahplus denkst – und hilf uns so, unsere Software
                noch besser zu machen. <br /> Dein ehrliches Feedback zählt – und dauert nicht länger als 2 Minuten.
            </Typography>
            <StyledButton color="info" size="large" variant="contained" onClick={onStartFeedback}>
                Los geht's
            </StyledButton>
        </StyledDiv>
    )
})

export default FeedbackIntro
